import { BfiCustomStore } from '../common/SharedComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import BfiLevelReferenceTable from './tables/BfiLevelReferenceTable';
import Experience20PercentOwnerTotalsTable from './tables/Experience20PercentOwnerTotalsTable';
import ExperienceNot20PercentOwnerTotalsTable from './tables/ExperienceNot20PercentOwnerTotalsTable';
import ExperienceGrandTotalsTable from './tables/ExperienceGrandTotalsTable';

export const ExperienceLevelSection = ({ principalId }) => {
    const bfiLevelReferenceStore = new BfiCustomStore();
    const twentyPercentOwnerStore = new BfiCustomStore();
    const notTwentyPercentOwnerStore = new BfiCustomStore();
    const grandTotalsStore = new BfiCustomStore();

    const styles = {
        headerIcon: {
            fontSize: '1.5rem',
            fontWeight: '100',
            color: '#2196f3',
        },
    };

    if (!principalId) {
        return null;
    }

    return (
        <div style={{ margin: '10px' }}>
            <h2 className='decorated'>Construction Matrix</h2>
            <div className='row'>
                <BfiLevelReferenceTable
                    principalId={principalId}
                    gridStore={bfiLevelReferenceStore}
                />
            </div>
            <h2 className='decorated'>Experience Totals</h2>
            <div
                className='row'
                style={{ margin: '10px' }}
            >
                <div className='columns small-12 large-6'>
                    <div className='card'>
                        <div style={{ padding: '10px' }}>
                            <div style={{ padding: '5px', fontWeight: 'bold' }}>As 20% Owner</div>
                            <Experience20PercentOwnerTotalsTable
                                principalId={principalId}
                                gridStore={twentyPercentOwnerStore}
                            />
                        </div>
                    </div>
                </div>
                <div className='columns small-12 large-6'>
                    <div className='card'>
                        <div style={{ padding: '10px' }}>
                            <div style={{ padding: '5px', fontWeight: 'bold' }}>NOT 20% Owner</div>
                            <ExperienceNot20PercentOwnerTotalsTable
                                principalId={principalId}
                                gridStore={notTwentyPercentOwnerStore}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                className='row'
                style={{ margin: '10px' }}
            >
                <div className='columns small-12 large-4'>
                    <div className='card'>
                        <div style={{ padding: '10px' }}>
                            <div style={{ padding: '10px', fontWeight: 'bold' }}>
                                <div style={{ width: '100%' }}>
                                    Experience by Apply Type
                                    <div
                                        style={{
                                            height: '24px',
                                            width: '24px',
                                            float: 'right',
                                        }}
                                        className='experienceLevelDescriptor'
                                    >
                                        <FontAwesomeIcon
                                            icon={faCircleQuestion}
                                            style={styles.headerIcon}
                                        />
                                        <span className='text'>
                                            Experience for each Type.
                                            <br />
                                            One property may count for more than one row.
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <ExperienceGrandTotalsTable
                                principalId={principalId}
                                gridStore={grandTotalsStore}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExperienceLevelSection;
